import { URLS } from '../../../constants';
import apiClient from '../../client';

const getEventsByProvidersAPI = {
  getEventsByProviders: ({
    userIds,
    appointmentStartDate,
    appointmentEndDate,
    appointmentWith,
  }: {
    userIds: any;
    appointmentStartDate: any;
    appointmentEndDate: any;
    appointmentWith?: { id: any; type: string } | null;
  }) =>
    apiClient.post(URLS.getEventsByProviders, {
      data: {
        userIds,
        appointmentStartDate,
        appointmentEndDate,
        ...(appointmentWith ? { appointmentWith } : {}),
      },
    }),
};
export default getEventsByProvidersAPI;
